import { TAssetType } from './requestTypes';

export const appDomain = process.env.REACT_APP_URL;
export const menuList = [
  {
    label: 'Home',
    link: '/',
  },
  {
    label: 'Logout',
    link: '#',
  },
];

export const ASSETS_TYPES: { label: string; value: TAssetType }[] = [
  {
    label: 'Акции',
    value: 'stock',
  },
  {
    label: 'Фонды',
    value: 'etf',
  },
  {
    label: 'Металлы',
    value: 'metal',
  },
];
